import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import CityDistanceServices from "services/CityDistanceServices";
import { notifyError, notifySuccess } from "utils/toast";

const useCitySubmit = (id) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedFromCity, setSelectedFromCity] = useState();
  const [selectedToCity, setSelectedToCity] = useState();
  const [time, setTime] = useState();

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  
  
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setIsSubmitting(true);

      const CityData = {
        "from_city": selectedFromCity,
        "to_city": selectedToCity,
        "distance": data.distance,
        "duration": time
      };


      if (id) {
        const res = await CityDistanceServices.updateCity(id, CityData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await CityDistanceServices.addCity( CityData );
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getCityData = async () => {
    try {
      const res = await CityDistanceServices.getCityById(id);

      if (res) {
        setSelectedFromCity(res.data.from_city);
        setSelectedToCity(res.data.to_city);
        setTime(res.data.duration);
        setValue("distance", res.data.distance);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      // Clear form values and states when the drawer is closed
      setValue("distance", "");
      clearErrors();
      return;
    }

    if (id) {
      getCityData();
    }else{
    setValue("distance", "");
    setSelectedFromCity();
    setSelectedToCity();
    setTime();
    clearErrors();
    return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isSubmitting,loading,setLoading,
    selectedFromCity,
    selectedToCity,
    setSelectedFromCity,
    setSelectedToCity,
    time, setTime
  };
};

export default useCitySubmit;
